import { collection, doc, getDocs, limit, orderBy, query, setDoc, updateDoc, where } from "firebase/firestore";
import { defineComponent, reactive, watch } from "vue";
import { printDate, printFullDate, printTime } from "../../../module/format-date";
import { computed } from "vue";
import { createApp } from "vue";
import { firebaseStore } from "../../../firebase";
import { onMounted, onUpdated } from "vue";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
export const initWeboothDetailChat = () => {
    const app = document.getElementById("webooth-chat-app");
    if (app == null) {
        return;
    }
    // bladeファイルからjsに連携しないといけないデータが存在しない場合、初期化しない
    const jsIntegration = JSON.parse(document.querySelector("#js-integration")?.innerHTML || "{}");
    if (Object.keys(jsIntegration).length !== 0) {
        const vm = createApp(weboothChatVApp).mount("#webooth-chat-app");
    }
};
export const weboothChatVApp = defineComponent({
    setup() {
        // NOTE: 必要なデータをbladeファイルからjsに連携している
        const jsIntegration = JSON.parse(document.querySelector("#js-integration")?.innerHTML || "{}");
        const state = reactive({
            me: {
                name: jsIntegration.me.name,
                userId: jsIntegration.me.id,
                iconChar: jsIntegration.me.name.substring(0, 1),
            },
            seriesId: Number(jsIntegration.seriesId),
            weboothSlotId: Number(jsIntegration.weboothSlotId),
            supplierId: jsIntegration.supplierId,
            companyName: jsIntegration.companyName,
            roomId: "",
            room: null,
            messages: [],
            chatModalVisible: false,
            inputMessage: "",
            firstMessage: false,
            busy: false,
            timerId: null,
            msgCount: 0,
            absenceMessage: jsIntegration.absenceMessage,
        });
        onMounted(async () => {
            const chatIds = ["button-chat", "webooth-button-chat"];
            for (const index in chatIds) {
                const chatButton = document.getElementById(chatIds[index]);
                if (chatButton != null) {
                    chatButton.addEventListener("click", async function () {
                        state.chatModalVisible = true;
                        await checkExistChatRoom();
                        // 以前のチャットがない場合、チャットルームを新規作成
                        if (state.firstMessage) {
                            state.firstMessage = false;
                            await createChatRoom();
                        }
                        // チャット取得
                        await fetchMessages();
                    });
                }
            }
        });
        // チャットメッセージの更新
        onUpdated(async () => {
            // Refresh messages
            const mq = query(collection(firebaseStore, "rooms", state.roomId, "messages"), orderBy("sentAt"));
            const updateData = await getDocs(mq);
            const msgs = [];
            updateData.forEach(async (message) => {
                msgs.push(message.data());
            });
            state.messages = msgs;
            state.msgCount = state.messages.length;
        });
        // タイマーをスタート
        const startTimer = () => {
            state.timerId = setTimeout(() => {
                absenceMessage();
            }, 60000 * 5);
        };
        const checkExistChatRoom = async () => {
            const q = query(collection(firebaseStore, "rooms"), where("weboothSlotId", "==", jsIntegration.weboothSlotId), where("userId", "==", jsIntegration.me.id));
            const res = await getDocs(q);
            if (res.empty) {
                state.firstMessage = true;
            }
        };
        const fetchMessages = async () => {
            const q = query(collection(firebaseStore, "rooms"), where("weboothSlotId", "==", jsIntegration.weboothSlotId), where("userId", "==", jsIntegration.me.id));
            const res = await getDocs(q);
            // NOTE: データは一つしか返ってこないが、Collectionで返されるのでforEachする
            res.forEach(async (room) => {
                state.room = room.data();
                state.roomId = room.id;
                const mq = query(collection(firebaseStore, "rooms", room.id, "messages"), orderBy("sentAt"), limit(100));
                const data = await getDocs(mq);
                const messages = [];
                data.forEach(async (message) => {
                    messages.push(message.data());
                });
                state.messages = messages;
            });
        };
        const createChatRoom = async () => {
            const q = query(collection(firebaseStore, "rooms"), where("weboothSlotId", "==", jsIntegration.weboothSlotId), where("userId", "==", jsIntegration.me.id));
            const res = await getDocs(q);
            if (res.empty) {
                const uuid = uuidv4();
                const room = {
                    seriesId: state.seriesId,
                    weboothSlotId: state.weboothSlotId,
                    supplierId: state.supplierId,
                    userId: state.me.userId,
                };
                await setDoc(doc(firebaseStore, "rooms", uuid), room).then(async () => {
                    state.roomId = uuid;
                    const chatMessageRef = collection(firebaseStore, "rooms", uuid, "messages");
                    const item = {
                        roomId: uuid,
                        content: jsIntegration.welcomeMessage,
                        type: "message__plain-text",
                        supplierMessage: true,
                        opened: true,
                        sentAt: {
                            seconds: Math.floor(Date.now() / 1000),
                            nanoseconds: 0,
                        },
                    };
                    await setDoc(doc(chatMessageRef), item).then(async () => {
                        await fetchMessages();
                    });
                });
            }
        };
        // NOTE: メッセージを日付毎にグルーピングした配列を返す
        const currentMessages = computed(() => {
            if (state.messages.length < 1) {
                return [];
            }
            const v = {};
            const dates = [];
            state.messages.forEach((message) => {
                const date = printFullDate(message.sentAt.seconds);
                // ソート用の配列
                dates.push(date);
                if (v[date] == null) {
                    v[date] = [];
                }
                v[date].push(message);
            });
            const res = [];
            Array.from(new Set(dates)).forEach((date) => {
                const unixtime = v[date][0].sentAt.seconds;
                const d = new Date(unixtime).getFullYear() === new Date().getFullYear() ? printDate(unixtime) : printFullDate(unixtime);
                res.push({
                    date: d,
                    messages: v[date],
                });
            });
            return res;
        });
        const printMessageTime = (unixtime) => {
            return printTime(unixtime);
        };
        const handleRawHtmlMessageClicked = (event, sourceElement) => {
            // 商談オファーメッセージ内にあるリンクがクリックされた場合のハンドリング
            if (sourceElement instanceof HTMLAnchorElement && sourceElement.dataset.linkTo === "supplier-offer") {
                const reservationCalendarUrl = document.querySelector("#reservation_calendar_url");
                if (reservationCalendarUrl != null) {
                    globalThis.location.assign(reservationCalendarUrl.value);
                    event.preventDefault();
                }
            }
        };
        const handleToggleChat = async () => {
            // HACK: キャッシュを使用して表示するとCSSが当たる前にコンポーネントが表示されてしまうので、
            // CSSのロードが完了してる1tick後にScroll処理をした後、詳細ページを表示する。
            setTimeout(() => {
                const chatArea = document.querySelector("#modal-chat-area");
                if (chatArea != null) {
                    chatArea.scrollTo(0, chatArea.scrollHeight);
                }
                state.chatModalVisible = !state.chatModalVisible;
            }, 500);
            // 既読付ける
            // NOTE: bulk update出来ないのでメッセージを個別にupdateする
            if (state.messages.length < 1) {
                return;
            }
            const lastMessage = state.messages[state.messages.length - 1];
            const q = query(collection(firebaseStore, "rooms", state.roomId, "messages"), where("sentAt", "<=", lastMessage.sentAt));
            const data = await getDocs(q);
            data.forEach(async (v) => {
                const message = v.data();
                if (message.supplierMessage) {
                    await updateDoc(v.ref, { opened: true });
                }
            });
            // Refresh messages
            const mq = query(collection(firebaseStore, "rooms", state.roomId, "messages"), orderBy("sentAt"));
            const v = await getDocs(mq);
            const msgs = [];
            v.forEach(async (message) => {
                msgs.push(message.data());
            });
            state.messages = msgs;
        };
        const handleSendMessage = async () => {
            if (state.busy) {
                return;
            }
            if (state.inputMessage === "") {
                return;
            }
            try {
                state.busy = true;
                const item = {
                    roomId: state.roomId,
                    content: state.inputMessage,
                    supplierMessage: false,
                    opened: false,
                    sentAt: {
                        seconds: Math.floor(Date.now() / 1000),
                        nanoseconds: 0,
                    },
                };
                const ref = collection(firebaseStore, "rooms", state.roomId, "messages");
                await setDoc(doc(ref), item).then(() => {
                    state.inputMessage = "";
                    state.messages.push(item);
                    // HACK: キャッシュを使用して表示するとCSSが当たる前にコンポーネントが表示されてしまうので、
                    // CSSのロードが完了してる1tick後にScroll処理をした後、詳細ページを表示する。
                    setTimeout(() => {
                        const chatArea = document.querySelector("#modal-chat-area");
                        if (chatArea != null) {
                            chatArea.scrollTo(0, chatArea.scrollHeight);
                        }
                    }, 500);
                });
                await sendNotificationEmail(state.room.weboothSlotId, item.content);
                await checkSupplierLogin();
            }
            catch {
                // logging
            }
            finally {
                state.busy = false;
            }
        };
        const sendNotificationEmail = async (weboothSlotId, message) => {
            const param = {
                template_type: "message",
                message: message,
                target_webooth_slot_id: weboothSlotId,
            };
            try {
                await axios.post("/api/user/send-chat-notification-email", param);
            }
            catch (error) {
                window.console.error(error);
            }
        };
        const resizeMessageAreaHeight = (e) => {
            const textArea = e.target;
            if (textArea != null) {
                // 3行以上の高さ(77px = 3rem(1rem=14px) + 20px(padding))には設定しない
                if (Number(textArea.scrollHeight) <= 77) {
                    // 改行が削除された場合に、一度リセットする
                    textArea.style.height = "auto";
                    textArea.style.height = textArea.scrollHeight + "px";
                }
            }
        };
        const absenceMessage = async () => {
            const room = {
                seriesId: state.seriesId,
                weboothSlotId: state.weboothSlotId,
                supplierId: state.supplierId,
                userId: state.me.userId,
            };
            await setDoc(doc(firebaseStore, "rooms", state.roomId), room).then(async () => {
                const chatMessageRef = collection(firebaseStore, "rooms", state.roomId, "messages");
                const item = {
                    roomId: state.roomId,
                    content: state.absenceMessage,
                    type: "message__plain-text",
                    supplierMessage: true,
                    opened: true,
                    sentAt: {
                        seconds: Math.floor(Date.now() / 1000) + 1,
                        nanoseconds: 0,
                    },
                };
                await setDoc(doc(chatMessageRef), item).then(async () => {
                    await fetchMessages();
                });
            });
        };
        // チャット中のサプライヤーがログイン中なのかチェック
        const checkSupplierLogin = async () => {
            const param = {
                supplier_id: state.supplierId,
            };
            try {
                const response = await axios.post("/api/user/check-supplier-login", param);
                if (!response.data.status) {
                    await absenceMessage();
                }
                else {
                    startTimer();
                }
            }
            catch (error) {
                window.console.error(error);
            }
        };
        const shouldRenderRawHtmlMessage = (message) => {
            return message.type === "offer__business";
        };
        watch(() => state.msgCount, (updateCount, prevCount) => {
            if (state.timerId !== null) {
                if (updateCount != prevCount) {
                    clearTimeout(state.timerId);
                    state.timerId = null;
                }
            }
        });
        return {
            state,
            currentMessages,
            printMessageTime,
            handleRawHtmlMessageClicked,
            handleToggleChat,
            handleSendMessage,
            resizeMessageAreaHeight,
            shouldRenderRawHtmlMessage,
        };
    },
});
